import HealthStatMeter, { MeterLabel } from './HealthStatMeter';
import PricePointMetricIcon from './PricePointMetricIcon';
import Stack from '../Stack';
import styled from 'styled-components';
import { tooltips } from '@/copy';

const PricePointLabel = styled.span`
    font-size: 0.875em;
    font-weight: ${({ theme }) => theme.fontBold};
    color: ${({ theme }) => theme.gray_3};
`;

const MetricTooltipWrapper = styled.div`
    font-family: ${({ theme }) => theme.style_primary};
    padding: 1rem 1.5rem;
`;

const MetricTooltipSummary = styled.span`
    font-size: 12px;
    line-height: 15px;
    font-weight: bold;
`;

const ScoreMetersWrapper = styled.div`
    margin-top: 1rem;
    font-weight: 400;
    display: flex;
    flex-direction: row;
`;

const ScoreMeterRow = styled(Stack)`
    margin-bottom: 0.5rem;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

const ScoreMeterCol = styled.div`
    width: 175px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const ScoreDescriptionCol = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const ScoreMeterDescription = styled.div`
    margin-left: 1rem;
    line-height: 15px;
    font-size: 12px;
`;

function MetricTooltipContent({ metricLabel }) {
    const { summary, scoreLabels, scoreDefinitions } =
        tooltips.healthStats[metricLabel];
    const sortedScoreLabels = Object.keys(scoreLabels).sort((a, b) => b - a);

    return (
        <MetricTooltipWrapper>
            <MetricTooltipSummary>{summary}</MetricTooltipSummary>
            <ScoreMetersWrapper>
                <ScoreMeterCol>
                    {sortedScoreLabels.map((key) => {
                        const score = parseInt(key, 10);

                        if (metricLabel === 'price point') {
                            return (
                                <ScoreMeterRow
                                    $direction="row"
                                    $space="1rem"
                                    css={`
                                        color: ${({ theme }) => theme.purple_1};
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                    `}
                                    key={score}
                                >
                                    <PricePointLabel
                                        css={`
                                            color: ${({ theme }) =>
                                                theme.purple_1};
                                        `}
                                    >
                                        {scoreLabels[score]}
                                    </PricePointLabel>
                                    <PricePointMetricIcon
                                        score={score}
                                        css={`
                                            color: ${({ theme }) =>
                                                theme.purple_1};
                                            font-size: 0.9em;
                                        `}
                                    />
                                </ScoreMeterRow>
                            );
                        }

                        if (metricLabel === 'popularity share') {
                            return (
                                <ScoreMeterRow
                                    $direction="row"
                                    $space="1rem"
                                    key={score}
                                >
                                    <MeterLabel
                                        css={`
                                            font-weight: ${({ theme }) =>
                                                theme.fontBold};
                                            font-size: 1em;
                                        `}
                                    >
                                        {scoreLabels[score]}
                                    </MeterLabel>
                                </ScoreMeterRow>
                            );
                        }

                        return (
                            <ScoreMeterRow $space=".75rem" key={score}>
                                <HealthStatMeter
                                    score={score}
                                    scoreLabel={scoreLabels[score]}
                                    metricLabel={metricLabel}
                                />
                            </ScoreMeterRow>
                        );
                    })}
                </ScoreMeterCol>
                <ScoreDescriptionCol>
                    {sortedScoreLabels.map((key) => (
                        <ScoreMeterDescription key={key}>
                            {scoreDefinitions[key] || ''}
                        </ScoreMeterDescription>
                    ))}
                </ScoreDescriptionCol>
            </ScoreMetersWrapper>
        </MetricTooltipWrapper>
    );
}

export default MetricTooltipContent;
